/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";

import MainAdministration from "layouts/mainAdministration";
import MainParkList from "layouts/mainParkList";
import MainStatistics from "layouts/mainStatistics";

import ParkAdministration from "layouts/parkAdministration";
import ParkDashboard from "layouts/parkDashboard";
import ParkStatistics from "layouts/parkStatistics";

import TurbineDashboard from "layouts/turbineDashboard";
import TurbineLiveCameraView from "layouts/turbineLiveCameraView";
import TurbineStatistics from "layouts/turbineStatistics";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
    {/* AUTHENTIFICATION */ },
    {
        type: "other",
        name: "SignIn",
        key: "signin",
        route: "/authentication/sign-in",
        component: <SignIn />,
    },
    {/* PROFILE */ },
    {
        type: "other",
        name: "Profile",
        key: "profile",
        route: "/profile",
        component: <Profile />,
    },
    {/* PARK LIST */ },
    {
        type: "topPaL",
        name: "Park List",
        key: "parkList",
        icon: <Icon fontSize="small">place</Icon>,
        route: "/parkList",
        component: <MainParkList />,
    },
    {
        type: "topPaL",
        name: "Statistics",
        key: "statistics",
        icon: <Icon fontSize="small">leaderboard</Icon>,
        route: "/statistics",
        component: <MainStatistics />,
    },
    {/* (adminAT / adminENGIE) */ },
    {
        type: "topLimitedPaL",
        name: "Administration",
        key: "administration",
        icon: <Icon fontSize="small">admin_panel_settings</Icon>,
        route: "/administration",
        component: <MainAdministration />,
    },
    {/* PARK DASHBOARD */ },
    {
        type: "topPaD",
        name: "Park Dashboard",
        key: "parkDashboard",
        icon: <Icon fontSize="small">dashboard</Icon>,
        route: "/parkDashboard",
        component: <ParkDashboard />,
    },
    {
        type: "topPaD",
        name: "Park Statistics",
        key: "parkStatistics",
        icon: <Icon fontSize="small">leaderboard</Icon>,
        route: "/parkStatistics",
        component: <ParkStatistics />,
    },
    {
        type: "topPaD",
        name: "Park Administration",
        key: "parkAdministration",
        icon: <Icon fontSize="small">admin_panel_settings</Icon>,
        route: "/parkAdministration",
        component: <ParkAdministration />,
    },
    {/* TURBINE DASHBOARD */},
    {
        type: "topTuD",
        name: "Turbine Dashboard",
        key: "turbineDashboard",
        icon: <Icon fontSize="small">dataset</Icon>,
        route: "/turbineDashboard",
        component: <TurbineDashboard />,
    },
    {
        type: "topTuD",
        name: "Turbine Statistics",
        key: "turbineStatistics",
        icon: <Icon fontSize="small">leaderboard</Icon>,
        route: "/turbineStatistics",
        component: <TurbineStatistics />,
    },
    {
        type: "topTuD",
        name: "Live Camera View",
        key: "turbineLiveCameraView",
        icon: <Icon fontSize="small">center_focus_strong</Icon>,
        route: "/turbineLiveCameraView",
        component: <TurbineLiveCameraView />,
    },
    {
        type: "bottomTuD",
        name: "Park Dashboard",
        key: "parkDashboard",
        icon: <Icon fontSize="small">arrow_back</Icon>,
        route: "/parkDashboard",
        component: <ParkDashboard />,
    },
    {/* PARK DASHBOARD & TURBINE DASHBOARD */ },
    {/* (adminAT / adminENGIE / adminPARK with several parks) */ },
    {
        type: "bottomMULTI",
        name: "Main Dashboard",
        key: "parkList",
        icon: <Icon fontSize="small">arrow_back</Icon>,
        route: "/parkList",
        component: <MainParkList />,
    },
];

export default routes;
